import { render, staticRenderFns } from "./UnsyncedList.vue?vue&type=template&id=a1bed552"
import script from "./UnsyncedList.ts?vue&type=script&lang=ts&external"
export * from "./UnsyncedList.ts?vue&type=script&lang=ts&external"
import style0 from "./UnsyncedList.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports